import { ISMT_CauTrucDe_Insert_Request } from "../../../model/request/de-thi/ISMT_CauTrucDe_Insert_Request";
import { IPhanPhoiDeThi, IPhanPhoiDeThi_History } from "../../../model/respone/de-thi/IPhanPhoiDeThi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhanPhoiDeThiActionsObj = {
  LOAD_START: {} as any,
  LOAD_SUCCESS: {} as {trongKhoTong: IPhanPhoiDeThi[], daPhanPhoi: IPhanPhoiDeThi[]},
  LOAD_ERROR: "",

  PHAN_PHOI_START: {} as any,
  PHAN_PHOI_SUCCESS: undefined,
  PHAN_PHOI_ERROR: "",

  THU_HOI_START: {} as any,
  THU_HOI_SUCCESS: undefined,
  THU_HOI_ERROR: "",

  LOAD_HISTORY_START: {} as any,
  LOAD_HISTORY_SUCCESS: {} as IPhanPhoiDeThi_History[],
  LOAD_HISTORY_ERROR: "",

  SHOW_PHAN_PHOI_MODAL: {} as undefined | IPhanPhoiDeThi,
  CLOSE_PHAN_PHOI_MODAL: undefined,

  SHOW_THU_HOI_MODAL: {} as undefined | IPhanPhoiDeThi,
  CLOSE_THU_HOI_MODAL: undefined,

  SHOW_HISTORY_MODAL: {} as any,
  CLOSE_HISTORY_MODAL: undefined,

  SELECTED_ID: [] as number[],

  CHANGE_REQUEST: {} as any,
};
export const ePhanPhoiDeThiActionIds = generateActionTypeIds(
  ePhanPhoiDeThiActionsObj,
  "PHAN_PHOI_DE_THI"
);
export type IPhanPhoiDeThiActionTypes = IGenericActionType<
  typeof ePhanPhoiDeThiActionsObj,
  "PHAN_PHOI_DE_THI"
>;
